const initGrowthbook = () => {
  const observer = new MutationObserver(() => {
    const urgencyCalloutMessage = document.querySelector(".cart__urgency-message");
    const messageWrapper = document.querySelector('.cart__footer-message');
    const categoryMobileWrapper = document.querySelector('.category-slides');

    if (urgencyCalloutMessage && !urgencyCalloutMessage.dataset.gbInitialized) {
      urgencyCalloutMessage.dataset.gbInitialized = "true";
      setupUrgencyCallout(urgencyCalloutMessage);
    }

    if (messageWrapper && !messageWrapper.dataset.gbInitialized) {
      messageWrapper.dataset.gbInitialized = "true";
      setupSidecartMessage(messageWrapper);
    }

     if (categoryMobileWrapper && !categoryMobileWrapper.dataset.gbInitialized) {
      categoryMobileWrapper.dataset.gbInitialized = "true";
      setupCategoryMobile(categoryMobileWrapper);
    }
    
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
};

function setupUrgencyCallout(wrapper) {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(_ => {
    const applyFeatureFlags = () => {
      const gb = window._growthbook;
      const value = gb?.getFeatureValue("urgency-callout", false);
      const holdout = gb?.getFeatureValue("holdout-pdm-bpn", "exposed");
      
      const shouldShow = holdout !== "holdout-q4-2025" && value === true;
      wrapper.classList.toggle("show", shouldShow);
    };
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
}

function setupCategoryMobile(wrapper) {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(_ => {
    const applyFeatureFlags = () => {
      const gb = window._growthbook;
      const value = gb?.getFeatureValue("category-mobile", false);
      const holdout = gb?.getFeatureValue("holdout-pdm-bpn", "exposed");
      
      const shouldShow = holdout !== "holdout-q4-2025" && value === true;
      wrapper.classList.toggle("show", shouldShow);
    };
    applyFeatureFlags();
    document.addEventListener("growthbookdata", applyFeatureFlags);
  });
}

function setupSidecartMessage(wrapper) {
  window.growthbook_queue = window.growthbook_queue || [];
  window.growthbook_queue.push(_ => {
    const applyFeatureFlags = () => {
      const gb = window._growthbook;
      const value = gb?.getFeatureValue('sidecart-message-test', false);
      const holdout = gb?.getFeatureValue('holdout-pdm-bpn', 'exposed');
      const textElement = wrapper.querySelector("p i");

      if (holdout === 'holdout-q4-2025' || !textElement) {
        wrapper.classList.remove('show');
        return;
      }

      const variants = {
        "variant-b": "Trusted by 530k+ Customers",
        "variant-c": "50,000+ 5-Star Reviews"
      };

      if (variants[value]) {
        textElement.textContent = variants[value];
        wrapper.classList.add('show');
      } else {
        wrapper.classList.remove('show');
      }
    };
    applyFeatureFlags();
    document.addEventListener('growthbookdata', applyFeatureFlags);
  });
}

export default initGrowthbook;